"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols"));
var _from = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/array/from"));
var _assign = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/assign"));
var _chainFunction = _interopRequireDefault(require("chain-function"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _react = _interopRequireWildcard(require("react"));
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _keycode = _interopRequireDefault(require("../keycode/keycode"));
var _SkipLink = _interopRequireDefault(require("../SkipLink/SkipLink"));
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _useFocusManager = _interopRequireDefault(require("../utils/useFocusManager"));
var _useFocusWithin2 = _interopRequireDefault(require("../utils/_useFocusWithin"));
var _useTypeToFocus2 = _interopRequireDefault(require("../utils/useTypeToFocus"));
var _navMenuUtils = require("./_navMenuUtils");
var _NavMenuBar = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./NavMenuBar.css") : void 0);
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof _getOwnPropertySymbols.default === "function") for (var i = 0, p = (0, _getOwnPropertySymbols.default)(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var CSS_BLOCK = 'sapcnqr-nav-menu-bar';
var NavMenuBar = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var _a;
  var ariaLabel = props.ariaLabel,
    children = props.children,
    className = props.className,
    hoverToOpen = props.hoverToOpen,
    skipLink = props.skipLink,
    listProps = props.listProps,
    navProps = __rest(props, ["ariaLabel", "children", "className", "hoverToOpen", "skipLink", "listProps"]);
  var classnames = _bind.default.bind(_NavMenuBar.default);
  var navMenuBarRef = (0, _react.useRef)();
  var mergedRef = (0, _reactMergeRefs.default)([navMenuBarRef, ref]);
  var _useFocusWithin = (0, _useFocusWithin2.default)({
      targetElement: navMenuBarRef.current
    }),
    isFocused = _useFocusWithin.isFocused;
  // this is needed to support left and right
  // keydown behavior for Submenu as per
  // https://www.w3.org/WAI/ARIA/apg/patterns/menubar/examples/menubar-navigation/#kbd_label
  var _useArrowBasedFocusTr = (0, _navMenuUtils.useArrowBasedFocusTraversal)(),
    moveFocusAndOpenNew = _useArrowBasedFocusTr.moveFocusAndOpenNew;
  var passChildProps = function passChildProps(child, childProps) {
    if (child.displayName === 'NavMenu') {
      return {
        hoverToOpen: hoverToOpen,
        inNavMenuBar: true,
        className: classnames(childProps === null || childProps === void 0 ? void 0 : childProps.className, "".concat(CSS_BLOCK, "__list-item"), (0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "--disabled"), childProps === null || childProps === void 0 ? void 0 : childProps.disabled)),
        moveFocusAndOpenNew: moveFocusAndOpenNew
      };
    }
    if (child.displayName === 'NavMenuItem') {
      return {
        hoverToOpen: hoverToOpen,
        className: classnames(childProps === null || childProps === void 0 ? void 0 : childProps.className, "".concat(CSS_BLOCK, "__list-item"), (0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "--disabled"), childProps === null || childProps === void 0 ? void 0 : childProps.disabled))
      };
    }
    return {};
  };
  var internalListRef = (0, _react.useRef)(null);
  (0, _useFocusManager.default)({
    nextKeyCode: _keycode.default.codes.right,
    previousKeyCode: _keycode.default.codes.left,
    firstFocusIndex: 0,
    suppressInitialAttachment: true,
    stopKeyPressPropagation: true,
    useHomeAndEndKeys: true,
    onlyContainedEvents: true
  }, !!isFocused, internalListRef);
  var _useTypeToFocus = (0, _useTypeToFocus2.default)({
      focusCandidates: (0, _from.default)(((_a = internalListRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll('[role="menuitem"]')) || []),
      keyStrokeTimeout: 50,
      focusMatchingItem: _navMenuUtils.focusMatchingItem
    }),
    handleTypeToFocus = _useTypeToFocus.handleTypeToFocus;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (skipLink === null || skipLink === void 0 ? void 0 : skipLink.url) && (skipLink === null || skipLink === void 0 ? void 0 : skipLink.label) ? ( /*#__PURE__*/_react.default.createElement(_SkipLink.default, (0, _assign.default)({}, skipLink))) : null, /*#__PURE__*/_react.default.createElement("nav", (0, _assign.default)({}, navProps, {
    "aria-label": ariaLabel,
    ref: mergedRef,
    className: classnames(className, CSS_BLOCK, navProps)
  }), /*#__PURE__*/_react.default.createElement("ul", (0, _assign.default)({}, listProps, {
    "aria-label": ariaLabel,
    className: classnames("".concat(CSS_BLOCK, "__list"), listProps === null || listProps === void 0 ? void 0 : listProps.className),
    role: "menubar",
    onKeyDown: (0, _chainFunction.default)(handleTypeToFocus, listProps === null || listProps === void 0 ? void 0 : listProps.onKeyDown),
    ref: (listProps === null || listProps === void 0 ? void 0 : listProps.ref) ? (0, _reactMergeRefs.default)([listProps.ref, internalListRef]) : internalListRef
  }), /*#__PURE__*/_react.default.createElement(_AddChildPropsContext.AddChildPropsProvider, {
    value: passChildProps
  }, children))));
});
NavMenuBar.displayName = 'NavMenuBar';
var _default = exports.default = NavMenuBar;